import { WalletService } from "@/services";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
export default {
  name: "update-in-table",
  components: {},
  props: [],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      newWallets: types.wallets.getters.GET_NEW_WALLETS
    })
  },
  mounted() {},
  methods: {
    ...mapActions({
      updateCheckWallets: types.wallets.actions.UPDATE_CHECK_WALLETS,
      setNewWallets: types.wallets.actions.SET_NEW_WALLETS
    }),
    updateWalletID(id) {
      this.loading = true;
      WalletService.updateWalletV4(id)
        .then(response => {
          this.loading = false;
          this.updateCheckWallets({
            id: id,
            show_update: false
          });
          this.$toast.success(response.data.message);
          WalletService.getWalletV4().then(res => {
            this.setNewWallets(res.data.data);
            setTimeout(() => {
              this.updateCheckWallets({
                id: id,
                show_update: true
              });
            }, response.data.data.user_check_wallet_interval);
          });
        })
        .catch(error => {
          this.$toast.error(error.data.message);
          if (error.status) {
            this.loading = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
